import { IdIdentifier, Timestamps } from '../common';
import { PaymentProvider } from '../payments/payment.enums';

export type ApplicationConfig = IdIdentifier &
  Timestamps & {
    disableTiktok: boolean;
    disableYoutube: boolean;
    disableInstagram: boolean;
    disableFacebook: boolean;
    maxCharsForScript: number;
    changelogDate?: string; // 06/01/2025
    paymentProvider?: PaymentProvider;
    /**
     * Provider-specific default discount identifier applied to new checkouts.
     * For PayPro this is the coupon code (e.g. `NINJA20`). For Polar it is the
     * discount UUID, since Polar's checkout API takes ids, not codes.
     */
    defaultDiscountId?: string;
  };

export const MAX_CHARS_DEFAULT = 2000;
